import React from 'react';
import PropTypes from 'prop-types';
import Tab from '@lwt-helix/tab';
import { agentProductionTerms as apt, marketShareTerms as mst } from '../../constants';

const Settings = ({ isMarketShareAllowed }) => {
    
    const getTabSettings = () => (
        [
            {
                title: apt.profile,
                content: {
                    jsx: <></>
                }
            },
            {
                title: apt.office,
                content: {
                    jsx: <></>
                }
            },
            {
                title: apt.mls,
                content: {
                    jsx: <></>
                }
            },
            {
                title: mst.comparisonSets,
                content: {
                    jsx: <></>
                }
            }
        ].filter(tab => isMarketShareAllowed || tab.title !== mst.comparisonSets)
    );
    const tabItems = getTabSettings();

    return (
        <>
            <h4>{apt.settings}</h4>
            <div className='d-flex w-100'>
                <Tab
                    contentSize={tabItems.length}
                    items={tabItems}
                    tabs
                    navSize={tabItems.length} />
            </div>
        </>
    );
};

Settings.propTypes = {
    isMarketShareAllowed: PropTypes.bool,
};

export default Settings;
